<template>
  <div class="first-pay" :class="{ complete: isComplete }">
    <div class="icon-complete"></div>
    <div class="content">
      <div class="btn" @click="$bus.$emit('welfare-events', 'toStore')">
        <div class="icon"></div>
        <div class="txt">{{ $t('text_recharge_now') }}</div>
      </div>
      <div class="tips">
        <div>* {{ $t('text_welfare_rule_1') }}</div>
        <div>* {{ $t('diamond_use_rule') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { storeInit } from '@/server/api'
import { mapState } from 'vuex'
export default {
  name: 'FirstPay',
  data () {
    return {
      isComplete: false
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo'
    })
  },
  methods: {
    init () {
      if (!this.$ENUM.FIRST_RECHARGE_PKGCHANNEL.includes(this.userInfo.real_pkg_channel)) {
        this.isComplete = false
        this.$emit('setDot', false)
        return
      }
      const params = {
        price: 0.99,
        product_id: 'com.kingsgroup.pc.diamond0',
        game_id: 30001,
        game_project: 'ss_global',
        source: 'web',
        country: 'HK',
        currency: 'USD',
        openid: this.userInfo.openid,
        uid: parseInt(this.userInfo.uid || 0)
      }
      storeInit(params).then(res => {
        if (res.is_first_pay) {
          this.isComplete = false
          this.$emit('setDot', true)
        } else {
          this.$bus.$emit('welfare-events', 'hideFirstPayIcon')
          this.isComplete = true
          this.$emit('setDot', false)
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped >
.first-pay {
  width: calc(1556 * var(--unit-px));
  height: calc(954 * var(--unit-px));
  background: url(~@/assets/img/welfare/bg_first.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  &.complete {
    .icon-complete {
      position: absolute;
      width: calc(349 * var(--unit-px));
      height: calc(264 * var(--unit-px));
      background: url(~@/assets/img/welfare/icon_complete.png) no-repeat center center;
      background-size: 100% 100%;
      top: calc(121 * var(--unit-px));
      left: calc(165 * var(--unit-px));
    }
  }
  .content {
    position: absolute;
    left: calc(456 * var(--unit-px));;
    right: 0;
    bottom: 0;
  }
  .btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(648 * var(--unit-px));
    height: calc(102 * var(--unit-px));
    background: url(~@/assets/img/welfare/bg_btn.png) no-repeat center center;
    background-size: 100% 100%;
    .icon {
      width: calc(64 * var(--unit-px));
      height: calc(51 * var(--unit-px));
      background: url(~@/assets/img/welfare/icon_diamond.png) no-repeat center center;
      background-size: 100% 100%;
    }
    .txt {
      font-size: calc(43 * var(--unit-px));
      font-weight: 600;
      color: #473232;
      line-height: 1;
      margin-left: 4px;
    }
  }
  .tips {
    margin-top: calc(26 * var(--unit-px));
    font-size: calc(30 * var(--unit-px));
    font-weight: 500;
    color: #FFFFFF;
    line-height: 1.4;
    text-shadow: 0px 2px 2px rgba(0,0,0,0.74);
  }
}
</style>
